import type { RegistrationWindowItem } from "@seagames/contracts";
import { useTranslation } from "react-i18next";

export type WindowState = "open" | "upcoming" | "closed";

/** Open now / Upcoming / Closed, from the viewer's clock (the server answers `is_open` by its own; this is a label). */
export function windowState(w: Pick<RegistrationWindowItem, "opens_at" | "closes_at">, now = Date.now()): WindowState {
	const opens = Date.parse(w.opens_at);
	const closes = Date.parse(w.closes_at);
	if (now < opens) return "upcoming";
	return now < closes ? "open" : "closed";
}

const TONE: Record<WindowState, string> = {
	open: "bg-[#e1f3e8] text-[#17663a] before:bg-[#17804a]",
	upcoming: "bg-[#e1eafe] text-[#1d4ed8] before:bg-[#2f62d9]",
	closed: "bg-gms-soft-2 text-gms-ink-3 before:bg-gms-ink-3",
};

export function WindowStatusPill({ state }: { state: WindowState }) {
	const { t } = useTranslation("registrationWindows");
	return (
		<span
			className={`inline-flex h-[1.375rem] items-center gap-[0.375rem] rounded-[0.25rem] px-[0.5rem] text-[0.71875rem] font-semibold whitespace-nowrap before:size-[0.4375rem] before:rounded-full before:content-[''] ${TONE[state]}`}
		>
			{t(`status.${state}`)}
		</span>
	);
}
